import { render, staticRenderFns } from "./VFieldSelect.vue?vue&type=template&id=023fdf04&"
import script from "./VFieldSelect.vue?vue&type=script&lang=js&"
export * from "./VFieldSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023fdf04')) {
      api.createRecord('023fdf04', component.options)
    } else {
      api.reload('023fdf04', component.options)
    }
    module.hot.accept("./VFieldSelect.vue?vue&type=template&id=023fdf04&", function () {
      api.rerender('023fdf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldSelect.vue"
export default component.exports